<template>
    <div>
        <div class="row">
            <div class="col-lg-2">
                <div class="form-group">
                    <label class="control-label">{{(authUser.company_id == 1898 || authUser.company_id == 2449 || authUser.company_id == 2493) ? 'Ficha' : 'Código'}}</label>
                    <input type="number" :disabled="(authUser.company_id == 1898 || authUser.company_id == 2449 || authUser.company_id == 2493) ? false : true" class="form-control" v-model="patient.code" @blur="checkDuplicity"/>
                </div>
            </div>
            <div class="col-lg-4">
                <div :class="[ $v.patient.name.required ? '' : 'has-error', 'form-group',  ]">
                    <label class="control-label">Nome</label>
                    <input type="text" class="form-control" v-model="patient.name" />
                </div>
            </div>
            <div class="col-lg-3">
                <div class="form-group">
                    <label class="control-label">Como deseja ser chamado</label>
                    <input type="text" class="form-control" v-model="patient.nickname" />
                </div>
            </div>
            <div class="col-lg-3">
                <div :class="[ $v.patient.register.dateRange && $v.patient.register.required ? '' : 'has-error', 'form-group',  ]">
                    <label class="control-label">Registro</label>
                    <input type="date" class="form-control" v-model="patient.register" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-3">
                <div :class="[ $v.patient.identification1.cpfCnpj ? '' : 'has-error', 'form-group',  ]">
                    <label class="control-label">CPF/CNPJ</label>
                    <input type="text" class="form-control" v-model="patient.identification1" v-mask="['###.###.###-##', '##.###.###/####-##']" @keyup="checkDuplicityByCpfCnpj">
                </div>
            </div>
            <div class="col-lg-3">
                <div class="form-group">
                    <label class="control-label">RG</label>
                    <input type="text" class="form-control" v-model="patient.identification2" />
                </div>
            </div>
            <div class="col-lg-3">
                <div class="form-group">
                    <label class="control-label">Órgão emissor</label>
                    <input type="text" class="form-control" v-model="patient.orgao_emissor_rg" />
                </div>
            </div>
            <div class="col-lg-3">
                <div class="form-group">
                    <label class="control-label">UF/RG</label>
                    <select class="form-control" v-model="patient.orgao_emissor_rg_uf_id">
                        <option :value="null">Selecione um estado</option>
                        <option v-for="(state, index) in optionsStates" :key="'states_'+index" :value="state.value">{{state.text}}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4">
                <div :class="[ $v.patient.email.email ? '' : 'has-error', 'form-group',  ]">
                    <label class="control-label">e-mail</label>
                    <input type="email" class="form-control" v-model="patient.email" />
                </div>
            </div>
            <div class="col-lg-2">
                <div :class="[ $v.patient.birthday.dateRange ? '' : 'has-error', 'form-group',  ]">
                    <label class="control-label">Nascimento</label>
                    <input type="date" class="form-control" v-model="patient.birthday" />
                </div>
            </div>
            <div class="col-lg-2">
                <div class="form-group">
                    <label class="control-label">Idade</label>
                    <input type="text" disabled class="form-control" :value="(calculateAge().years < 150 ? calculateAge().years : 0) + ' anos.'" />
                </div>
            </div>
            <div class="col-lg-2">
                <div class="form-group">
                    <label class="control-label">Estado civil</label>
                    <select class="form-control" v-model="patient.marital_status">
                        <option :value="null">Selecione</option>
                        <option value="single">Solteiro</option>
                        <option value="married">Casado</option>
                        <option value="separated">Divorciado</option>
                        <option value="cohabitant">Convivente</option>
                        <option value="widower">Viúvo</option>
                    </select>
                </div>
            </div>
            <div class="col-lg-2">
                <div class="form-group">
                    <label class="control-label">Gênero</label>
                    <select class="form-control" v-model="patient.gender">
                        <option value="undefined">Indefinido</option>
                        <option value="feminine">Feminino</option>
                        <option value="male">Masculino</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4" v-for="(phone, i) in patient.phones" :key="'phones_'+i">
                <div class="form-group">
                    <label class="control-label" v-if="phone.type == 'mobile'">Celular <small>(principal)</small></label>
                    <the-mask :masked="true" v-if="phone.type == 'mobile'" v-model="phone.number" type="tel" class="form-control" :mask="['(##) ####-####', '(##) #####-####']" placeholder="(__) _____-____" />
                    <label class="control-label" v-if="phone.type == 'phone'">Telefone</label>
                    <the-mask :masked="true" v-if="phone.type == 'phone'" v-model="phone.number" type="tel" class="form-control" :mask="['(##) ####-####', '(##) #####-####']" placeholder="(__) ____-____" />
                    <label class="control-label" v-if="phone.type == 'other'">Outro fone 1</label>
                    <the-mask :masked="true" v-if="phone.type == 'other'" v-model="phone.number" type="tel" class="form-control" :mask="['(##) ####-####', '(##) #####-####']" placeholder="(__) _____-____" />
                    <label class="control-label" v-if="phone.type == 'other_3'">Outro fone 2</label>
                    <the-mask :masked="true" v-if="phone.type == 'other_3'" v-model="phone.number" type="tel" class="form-control" :mask="['(##) ####-####', '(##) #####-####']" placeholder="(__) _____-____" />
                    <label class="control-label" v-if="phone.type == 'other_4'">Outro fone 3</label>
                    <the-mask :masked="true" v-if="phone.type == 'other_4'" v-model="phone.number" type="tel" class="form-control" :mask="['(##) ####-####', '(##) #####-####']" placeholder="(__) _____-____" />
                    <label class="control-label" v-if="phone.type == 'other_5'">Outro fone 4</label>
                    <the-mask :masked="true" v-if="phone.type == 'other_5'" v-model="phone.number" type="tel" class="form-control" :mask="['(##) ####-####', '(##) #####-####']" placeholder="(__) _____-____" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="panel with-nav-tabs panel-info">
                    <div class="panel-heading">
                        <ul class="nav nav-tabs">
                            <li class="active"><a href="#tab1primary" data-toggle="tab"><i class="fa fa-map-marker" aria-hidden="true"></i> ENDEREÇO</a></li>
                            <li><a href="#tabPlan" data-toggle="tab"><i class="fa fa-ambulance"></i> PLANO</a></li>
                            <li><a href="#tabResponsible" data-toggle="tab"><font-awesome-icon :icon="['fa', 'people-arrows']" /> RESPONSÁVEL</a></li>
                            <li><a href="#tab4primary" data-toggle="tab"><i class="fa fa-info-circle" aria-hidden="true"></i> INFORMAÇÕES ADICIONAIS</a></li>
                        </ul>
                    </div>
                    <div class="panel-body">
                        <div class="tab-content">
                            <div class="tab-pane fade in active" id="tab1primary">
                                <address-form @address="setAddress" ref="address"></address-form>
                            </div>

                            <div class="tab-pane fade" id="tabPlan">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <label class="control-label">Planos</label>
                                        <multiselect v-model="patient.plans" id="ajax1" label="name" track-by="id" placeholder="Nenhum" open-direction="bottom"
                                            selectLabel="Enter para selecionar."
                                            deselectLabel="Enter para remover."
                                            :options="plansOptions"
                                            :multiple="true"
                                            :searchable="true"
                                            :loading="isLoading"
                                            :preserve-search="true"
                                            :internal-search="false"
                                            :clear-on-select="true"
                                            :close-on-select="false"
                                            :max-height="450"
                                            :custom-label="codeWithNameLabel"
                                            :show-no-results="true"
                                            :hide-selected="false"
                                            @search-change="this.debouncedGetSearchPlans">
                                            <span slot="noOptions">Digite o nome ou o código dos planos desejados.</span>
                                            <span slot="noResult">Nenhum resultado encontrado.</span>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="tabResponsible">
                                <div class="row">
                                    <div class="col-lg-4">
                                        <div :class="[ $v.patient.responsible.name.required ? '' : 'has-error', 'form-group',  ]">
                                            <label class="control-label">Nome</label>
                                            <input type="text" class="form-control" :disabled="!$v.patient.responsible.identification1.cpfCnpj || !patient.responsible.identification1" v-model="patient.responsible.name" />
                                        </div>
                                    </div>
                                    <div class="col-lg-2">
                                        <div :class="[ $v.patient.responsible.identification1.cpfCnpj ? '' : 'has-error', 'form-group',  ]">
                                            <label class="control-label">CPF/CNPJ</label>
                                            <input type="text" class="form-control" v-model="patient.responsible.identification1" @keyup="searchResponsible" v-mask="['###.###.###-##', '##.###.###/####-##']">
                                        </div>
                                    </div>
                                    <div class="col-lg-2">
                                        <div class="form-group">
                                            <label class="control-label">RG</label>
                                            <input type="text" class="form-control" :disabled="!$v.patient.responsible.identification1.cpfCnpj || !patient.responsible.identification1" v-model="patient.responsible.identification2" />
                                        </div>
                                    </div>
                                    <div class="col-lg-2">
                                        <div class="form-group">
                                            <label class="control-label">Órgão emissor</label>
                                            <input type="text" class="form-control" :disabled="!$v.patient.responsible.identification1.cpfCnpj || !patient.responsible.identification1" v-model="patient.responsible.orgao_emissor_rg" />
                                        </div>
                                    </div>
                                    <div class="col-lg-2">
                                        <div class="form-group">
                                            <label class="control-label">Parentesco</label>
                                            <select class="form-control" :disabled="!$v.patient.responsible.identification1.cpfCnpj || !patient.responsible.identification1" v-model="patient.responsible.kinship">
                                                <option :value="null">Selecione</option>
                                                <option value="FATHER">Pai</option>
                                                <option value="MOTHER">Mãe</option>
                                                <option value="RELATIVE">Parente</option>
                                                <option value="OTHER">Outro</option>
                                            </select>
                                        </div>
                                    </div>




                                </div>
                                <div class="row">
                                    <div class="col-lg-3">
                                        <div class="form-group">
                                            <label class="control-label">UF/RG</label>
                                            <select class="form-control" :disabled="!$v.patient.responsible.identification1.cpfCnpj || !patient.responsible.identification1" v-model="patient.responsible.orgao_emissor_rg_uf_id">
                                                <option :value="null">Selecione um estado</option>
                                                <option v-for="(state, index) in optionsStates" :key="'states_'+index" :value="state.value">{{state.text}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div v-for="(email, index) in $v.patient.responsible.emails.$each.$iter" :key="'emails_'+index" class="col-lg-3">
                                        <div :class="[ email.email.email ? '' : 'has-error', 'form-group',  ]">
                                            <label class="control-label">e-mail</label>
                                            <input type="email" class="form-control" name="emails[]" :disabled="!$v.patient.responsible.identification1.cpfCnpj || !patient.responsible.identification1" v-model.trim="email.email.$model" />
                                        </div>
                                    </div>
                                    <div class="col-lg-2">{{patient.responsible.birthday.dateRange}}
                                        <div :class="[ $v.patient.responsible.birthday.dateRange ? '' : 'has-error', 'form-group',  ]">
                                            <label class="control-label">Nascimento</label>
                                            <input type="date" class="form-control" :disabled="!$v.patient.responsible.identification1.cpfCnpj || !patient.responsible.identification1" v-model="patient.responsible.birthday" />
                                        </div>
                                    </div>
                                    <div class="col-lg-2">
                                        <div class="form-group">
                                            <label class="control-label">Gênero</label>
                                            <select class="form-control" :disabled="!$v.patient.responsible.identification1.cpfCnpj || !patient.responsible.identification1" v-model="patient.responsible.gender">
                                                <option value="undefined">Indefinido</option>
                                                <option value="feminine">Feminino</option>
                                                <option value="male">Masculino</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-lg-2">
                                        <div class="form-group">
                                            <label class="control-label">Estado civil</label>
                                            <select class="form-control" v-model="patient.responsible.marital_status">
                                                <option :value="null">Selecione</option>
                                                <option value="single">Solteiro</option>
                                                <option value="married">Casado</option>
                                                <option value="separated">Divorciado</option>
                                                <option value="cohabitant">Convivente</option>
                                                <option value="widower">Viúvo</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-4" v-for="(phone, i) in patient.responsible.phones" :key="'responsible_phones_'+i">
                                        <label class="control-label" v-if="phone.type == 'mobile'">Celular</label>
                                        <the-mask :masked="true" v-if="phone.type == 'mobile'" :disabled="!$v.patient.responsible.identification1.cpfCnpj || !patient.responsible.identification1" v-model="phone.number" type="tel" class="form-control" :mask="['(##) ####-####', '(##) #####-####']" placeholder="(__) _____-____" />
                                        <label class="control-label" v-if="phone.type == 'phone'">Telefone</label>
                                        <the-mask :masked="true" v-if="phone.type == 'phone'" :disabled="!$v.patient.responsible.identification1.cpfCnpj || !patient.responsible.identification1" v-model="phone.number" type="tel" class="form-control" :mask="['(##) ####-####', '(##) #####-####']" placeholder="(__) ____-____" />
                                        <label class="control-label" v-if="phone.type == 'other'">Outro fone</label>
                                        <the-mask :masked="true" v-if="phone.type == 'other'" :disabled="!$v.patient.responsible.identification1.cpfCnpj || !patient.responsible.identification1" v-model="phone.number" type="tel" class="form-control" :mask="['(##) ####-####', '(##) #####-####']" placeholder="(__) _____-____" />
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <address-form @address="setResponsibleAddress" :disable="!$v.patient.responsible.identification1.cpfCnpj || !patient.responsible.identification1" ref="responsibleAddress"></address-form>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="tab4primary">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="form-group">
                                            <textarea class="form-control" rows="9" v-model="patient.observation"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="form-group">
                    <btn type="primary" @click="saveGeneralData" :disabled="savePatientButtonDisabled"><i class="fa fa-save" aria-hidden="true"></i> Salvar alterações</btn>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import { requiredIf, required, email } from "vuelidate/lib/validators";
import { cpfCnpj } from "../../../util/validateCpfCnpj";
import AddressForm from "../../../AddressForm";
import Multiselect from "vue-multiselect";
import {TheMask} from 'vue-the-mask'
import moment from "moment";

export default {
    
    name: "GeneralData",

    components: { Multiselect, TheMask, AddressForm },

    props: {
        patientProp: { type: Object },
        authUser: { type: Object },
    },

    data() {
        return {
            isLoading: false,
            optionsToast: { timeout: 6000, position: "topCenter" },
            optionsStates: [],
            plansOptions: [],
            savePatientButtonDisabled: false,

            patient: {
                id: null,
                code: null,
                name: null,
                nickname: null,
                register: new Date().toISOString().substr(0, 10),
                identification1: null,
                identification2: null,
                orgao_emissor_rg: null,
                orgao_emissor_rg_uf_id: null,
                marital_status: null,
                status: 1, //1 ativo e 0 inativo
                email: null,
                birthday: '',
                gender: 'undefined', //'male', 'feminine', 'undefined'
                observation: null,

                phones: [ 
                    {type: 'mobile', number:''}, {type: 'phone', number:''}, {type: 'other', number:''},
                    {type: 'other_3', number:''}, {type: 'other_4', number:''}, {type: 'other_5', number:''}
                ],
                emails: [
                    { email: null, type_email: 'secondary' },//principal - secondary (se eu quiser mais campos de email incluo mais um objeto - repetindo esta linha)
                ],
                address: {},

                plans: [],

                responsible:{
                    id: null,
                    name: null,
                    identification1: null,
                    identification2: null,
                    orgao_emissor_rg: null,
                    orgao_emissor_rg_uf_id: null,
                    marital_status: null,
                    emails: [
                        { email: null, type_email: 'principal' },//principal - secondary (se eu quiser mais campos de email incluo mais um objeto - repetindo esta linha)
                    ],
                    birthday: '',
                    gender: 'undefined', //'male', 'feminine', 'undefined'
                    kinship: null,
                    phones: [
                        {type: 'mobile', number:''},
                        {type: 'phone', number:''},
                        {type: 'other', number:''}
                    ],
                    address: {},
                }
            }
        }
    },

    created() {
        // _.debounce é uma função fornecida pelo lodash para limitar a frequência que uma operação complexa pode ser executada.
        // Neste caso, queremos limitar a frequência com que acessamos a api, esperando que o usuário termine completamente
        // a digitação antes de realizar a chamada Ajax. Para aprender mais sobre a função _.debounce (e sua prima _.throttle),
        // visite: https://lodash.com/docs#debounce
        this.debouncedGetSearchPlans = _.debounce(this.searchPlans, 500);
    },

    mounted () {
        this.optionsStates = this.$refs.address.optionsStates;
        Object.assign(this.patient, this.patientProp)
        this.patient.register = this.patient.register.substr(0, 10)

        if(this.patientProp.responsible){
            Object.assign(this.$refs.responsibleAddress.address, this.patientProp.responsible.addresses[0])
        } else {
            this.patient.responsible = {
                name: null,
                birthday:'', 
                identification1: null, 
                emails: [
                        { email: null, type_email: 'principal' },//principal - secondary (se eu quiser mais campos de email incluo mais um objeto - repetindo esta linha)
                ],
            }
        }
        const phonesModel = [
            {type: 'mobile', number:''}, {type: 'phone', number:''}, {type: 'other', number:''},
            {type: 'other_3', number:''}, {type: 'other_4', number:''}, {type: 'other_5', number:''}
        ]
        const phonesDb = this.patientProp.phones.map((p) => { return {type:p.phone_type, number:p.phone}})
        this.patient.phones = phonesModel.map((current, index) => {
            let phone = phonesDb.find(element => element.type == current.type)
            return phone || current
        })
        if(this.patientProp.addresses){
            this.patient.address = this.patientProp.addresses[0],
            Object.assign(this.$refs.address.address,this.patient.address)
        }
        this.patient.plans = this.patientProp.dental_plans
    },

    validations: {
        patient: {
            name: { required },
            identification1: { cpfCnpj },
            email: { email },
            birthday: {
                dateRange: date => {
                    if(date && date.length === 10 ) {
                        return moment(date,"YYYY-MM-DD").isBetween('1901-01-01', '2200-12-31', null, '[]')
                    } else if(date && date.length > 10) {
                        return false
                    } 
                    return true
                },
            },
            register: {
                dateRange: date => {
                    if(date && date.length === 10 ) {
                        return moment(date,"YYYY-MM-DD").isBetween('1901-01-01', '2200-12-31', null, '[]')
                    } else if(date && date.length > 10) {
                        return false
                    }
                    return true
                }, required,
            },
            responsible: {
                identification1: { cpfCnpj },
                name:{required: requiredIf(function () { return !!this.patient.responsible.identification1 })},
                emails: {
                    $each: {
                        email: { email }
                    }
                },
                birthday: {
                    dateRange: date => {
                        if(date && date.length === 10 ) {
                            return moment(date,"YYYY-MM-DD").isBetween('1901-01-01', '2200-12-31', null, '[]')
                        } else if(date && date.length > 10) {
                            return false
                        }
                        return true
                    },
                },
            }
        },
        validationGroupPatient: ["patient"],
    },

    methods:{
        async checkDuplicity(){
            if(this.patient.code != this.patientProp.code){
                try {
                    const response = await axios.post("/patient/checkDuplicity/",{code:this.patient.code});
                    if(response.data > 0){
                        this.$toast.warning( "Já existe um paciente cadastrado com este código.", "AVISO", this.optionsToast );
                        this.savePatientButtonDisabled = true
                    } else {
                        this.savePatientButtonDisabled = false
                    }
                } catch (error) {
                    console.log(error);
                    if (error.response.status === 401 || error.response.status === 419) {
                        this.$toast.warning( "Sua sessão expirou. Por favor atualize a página.", "AVISO", this.optionsToast );
                    } else {
                        this.$toast.error( error.response.data.message, "Erro", this.optionsToast );
                    }
                }
            } else {
                this.savePatientButtonDisabled = false
            }
        },

        async checkDuplicityByCpfCnpj(){
            let identification = this.patient.identification1
            if(identification.length == 14 || identification.length == 18){
                if(this.patient.identification1 != this.patientProp.identification1){
                    try {
                        const response = await axios.post("/patient/checkDuplicityByCpf/",{identification1:this.patient.identification1});
                        console.log(response.data)
                        if(response.data > 0){
                            this.$toast.warning( "Já existe um paciente cadastrado com este cpf.", "AVISO", this.optionsToast );
                            // this.savePatientButtonDisabled = true
                        } else {
                            // this.savePatientButtonDisabled = false
                        }
                    } catch (error) {
                        console.log(error);
                        if (error.response.status === 401 || error.response.status === 419) {
                            this.$toast.warning( "Sua sessão expirou. Por favor atualize a página.", "AVISO", this.optionsToast );
                        } else {
                            this.$toast.error( error.response.data.message, "Erro", this.optionsToast );
                        }
                    }
                } else {
                    this.savePatientButtonDisabled = false
                }
            }
        },


        calculateAge(date = this.patient.birthday) {
            if(date && date.length === 10){
                if(moment(date, "YYYY-MM-DD").isValid()){
                    const years = moment().diff(date, 'years');
                    const days = moment().diff(date, 'days');
                    return {
                        years: years >= 0 ? years : 0,
                        days: days >= 0 ? days : 0
                    }
                }
            }
            return { years: 0, days: 0 }
        },

        setAddress(address){
            this.patient.address = address
        },

        setResponsibleAddress(address){
            this.patient.responsible.address = address
        },

        async searchResponsible(){
            let identification = this.patient.responsible.identification1
            if(identification.length == 14 || identification.length == 18){
                const cpf_cnpj = identification.replace(/\D/g, '')
                try {
                    const response = await axios.get("/responsible/getByIdentification/"+cpf_cnpj);

                    if (_.isEmpty(response.data)) {

                        console.log('no responsible')
                        
                    } else {
                        this.patient.responsible = {
                            id: response.data.id,
                            name: response.data.name,
                            identification1: response.data.identification1,
                            identification2: response.data.identification2,
                            orgao_emissor_rg: response.data.orgao_emissor_rg,
                            orgao_emissor_rg_uf_id: response.data.orgao_emissor_rg_uf_id,
                            emails: response.data.emails,
                            birthday: response.data.birthday ? response.data.birthday.substring(0,10) : '',
                            gender: response.data.gender, //'male', 'feminine', 'undefined'
                            kinship: response.data.kinship, //'male', 'feminine', 'undefined'
                            phones: response.data.phones,
                            address: response.data.addresses[0],
                        }
                        this.$refs.responsibleAddress.address = this.patient.responsible.address
                    }
                } catch (error) {
                    console.log(error);
                    if (error.response.status === 401 || error.response.status === 419) {
                        this.$toast.warning( "Sua sessão expirou. Por favor atualize a página.", "AVISO", this.optionsToast );
                    } else {
                        this.$toast.error( error.response.data.message, "Erro", this.optionsToast );
                    }
                }

            } else {
                this.patient.responsible.id = null,
                this.patient.responsible.name = null,
                this.patient.responsible.identification2 = null,
                this.patient.responsible.orgao_emissor_rg = null,
                this.patient.responsible.orgao_emissor_rg_uf_id = null,
                this.patient.responsible.emails = [{ email: null, type_email: 'principal' }],//principal - secondary (se eu quiser mais campos de email incluo mais um objeto - repetindo esta linha)
                this.patient.responsible.birthday = '',
                this.patient.responsible.gender = 'undefined', //'male', 'feminine', 'undefined'
                this.patient.responsible.kinship = null,
                this.patient.responsible.phones = [{type: 'mobile', number:''},{type: 'phone', number:''},{type: 'other', number:''}],//principal - secondary (se eu quiser mais campos de email incluo mais um objeto - repetindo esta linha)
                this.patient.responsible.address = {},

                this.$refs.responsibleAddress.resetAddress()
            }
        },

        async saveGeneralData() {
            if (this.$v.validationGroupPatient.$invalid) {
                this.$toast.warning("Por favor revise os campos obrigatórios", "Aviso", this.optionsToast);
                return false
            }

            try {
                const response = await axios.put("/patient/"+this.patient.id, this.patient)
                if (response.data.type == "success") {
                    this.$toast.success( response.data.message, response.data.title, this.optionsToast )
                } else if (response.data.type == "warning") {
                    this.$toast.warning( response.data.message, response.data.title, this.optionsToast )
                } else {
                    this.$toast.info( response.data.message, response.data.title, this.optionsToast )
                }
            } catch (error) {
                console.log(error);
                if (error.response.status === 401 || error.response.status === 419) {
                    this.$toast.warning("Sua sessão expirou. Por favor atualize a página.", "AVISO", this.optionsToast)
                } else {
                    this.$toast.error(error.response.data.message, "Erro", this.optionsToast)
                }
            }
        },


        codeWithNameLabel({ code, name }) {
            return `${code} | ${name}`;
        },

        searchPlans(query) {
            this.isLoading = true;
            axios.post("/dental-plans/search", { kw: query })
                .then(
                    function (response) {
                        this.plansOptions = response.data;
                        this.isLoading = false;
                    }.bind(this)
                )
                .catch(function (error) {
                    console.log(error);
                });
        },

    }


}
</script>

<style>

</style>